// extracted by mini-css-extract-plugin
module.exports = {"root":"InvisibleLink_root__38KVM"};